module.exports = __webpack_public_path__ + "img/BrotherhoodArmor.700a57f7.gif";